export const reviews: Array<[string, string, string, string]> = [
  [
    'LP',
    'Laura P.',
    'Hydrology Educator — Manchester, United Kingdom',
    'My students finally understand the difference between surface water and groundwater systems. I used to waste hours searching for the right way to explain how water moves through the landscape. Now I enter the classroom fully prepared.',
  ],
  [
    'MK',
    'Michael K.',
    'Earth Science Instructor — Belfast, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain the hydrological cycle or how to calculate water balance. This resource does the heavy lifting for me.',
  ],
  [
    'CB',
    'Catherine B.',
    'Environmental Science Teacher — Rotterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated watershed projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'LP',
    'Laura P.',
    'Hydrology Educator | Manchester, United Kingdom',
    "The material on groundwater systems and aquifers completely changed how my students understand subsurface water. They finally grasp the connections between rainfall, infiltration, and water availability. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'MK',
    'Michael K.',
    'Earth Science Instructor | Belfast, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'DW',
    'David W.',
    'Environmental Science Teacher | Edinburgh, Scotland',
    "The 100 real-world case studies transformed how my students see water problems. Now they analyze authentic flooding, drought, and contamination challenges and understand why water management matters. I haven't found this quality in any other resource.",
  ],
  [
    'SM',
    'Sarah M.',
    'University Lecturer | Cambridge, United Kingdom',
    'The visual reference guide gave me back my class time. I used to spend twenty minutes explaining how aquifers work. Now I show the guide and students instantly understand the porosity and permeability concepts.',
  ],
  [
    'JP',
    'James P.',
    'Hydrology Instructor | Stockholm, Sweden',
    "The 50 integrated projects were eye-opening. My students finally understand why all this matters. They're studying local watersheds, analyzing water quality, and designing conservation strategies in their own communities. This completely transformed how they see hydrology.",
  ],
];
